import { Box } from "@chakra-ui/react";
import React from "react";

const Logo = ({ mt, ml }) => {
  return (
    <Box mt={mt} ml={ml}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        role="img"
        preserveAspectRatio="xMidYMid meet"
        width="200"
        height="100%"
        viewBox="0 0 5663.44 679.01"
      >
        <title>Mentimeter Logo</title>
        <g fill="#000000">
          <polygon
            fill="#FFB9D0"
            points="67.06 663 532.44 663 201.01 0 67.06 0 67.06 663"
          ></polygon>
          <polygon
            fill="#196CFF"
            points="602.86 0 602.86 133.95 468.91 133.95 468.91 267.9 334.96 267.9 334.96 663 736.81 663 736.81 0 602.86 0"
          ></polygon>
          <path
            fill="#FF80AB"
            d="M67.06,267.9V663H468.85C465.23,444.16,286.73,267.9,67.06,267.9Z"
          ></path>
          <path
            fill="#FF403D"
            d="M67.06,468.82V662.9h200.8C264.25,555.11,175.74,468.82,67.06,468.82Z"
          ></path>
          <rect y="662.97" width="803.87" height="13.41"></rect>
        </g>
        <g fill="#000000">
          <path d="M1797.7,0V669.45H1692.5V58.34L1536.62,669.45H1332.91L1178,58.34V669.45H1072.79V0h203.7L1436.2,629.28,1595.91,0Z"></path>
          <path d="M2329.46,438l-382.54,55.47c22,55.47,74.6,92.76,137.72,92.76,64.07,0,113.8-34.42,137.71-87l92.77,31.56C2277.82,616.85,2190.79,679,2083.68,679,1943.1,679,1836,570.94,1836,434.18c0-137.71,107.11-244.82,247.69-244.82S2331.37,294.56,2329.46,438Zm-115.72-65c-21-64.07-66-91.81-130.06-91.81-81.29,0-137.71,54.51-147.28,130.06Z"></path>
          <path d="M2794.27,362.46v307H2692.9V386.37c0-74.6-30.61-105.2-95.64-105.2-74.59,0-128.15,47.82-128.15,131V669.45H2367.74V198.92h101.37v67.9c30.61-51.64,87-77.46,151.11-77.46C2720.63,189.36,2794.27,249.61,2794.27,362.46Z"></path>
          <path d="M2992.25,198.92h146.32v82.25H2992.25v247.7c0,41.12,26.79,59.29,63.13,59.29,24.86,0,47.81-5.74,70.77-17.22v89.9c-21,9.56-58.34,17.21-85.12,17.21-101.38,0-150.15-47.81-150.15-149.18V281.17H2823V198.92h67.9V83.2L2992.25,5.74Z"></path>
          <path d="M3171.11,79.38a62.16,62.16,0,1,1,62.16,62.16A62,62,0,0,1,3171.11,79.38Zm13.39,119.54h101.37V669.45H3184.5Z"></path>
          <path d="M4014.6,356.72V669.45H3913.22V369.16c0-62.17-28.68-88-80.33-88s-104.24,41.13-104.24,115.72V669.45H3627.28V369.16c0-62.17-28.7-88-80.34-88S3442.7,322.3,3442.7,397.84V669.45H3341.33V198.92H3442.7V263c27.73-48.78,75.55-73.64,131-73.64,59.3,0,111.9,26.78,134.85,85.11,32.51-52.59,84.16-85.11,151.1-85.11C3946.7,189.36,4014.6,247.7,4014.6,356.72Z"></path>
          <path d="M4546.36,438l-382.54,55.47c22,55.47,74.6,92.76,137.72,92.76,64.07,0,113.8-34.42,137.71-87L4532,530.78C4494.72,616.85,4407.69,679,4300.58,679c-140.58,0-247.69-108.07-247.69-244.83,0-137.71,107.11-244.82,247.69-244.82S4548.28,294.56,4546.36,438Zm-115.72-65c-21-64.07-66-91.81-130.06-91.81-81.29,0-137.71,54.51-147.28,130.06Z"></path>
          <path d="M4716.62,198.92h146.32v82.25H4716.62v247.7c0,41.12,26.78,59.29,63.12,59.29,24.86,0,47.82-5.74,70.77-17.22v89.9c-21,9.56-58.34,17.21-85.12,17.21-101.37,0-150.15-47.81-150.15-149.18V281.17h-67.9V198.92h67.9V83.2L4716.62,5.74Z"></path>
          <path d="M5365,438l-382.54,55.47c22,55.47,74.6,92.76,137.71,92.76,64.08,0,113.81-34.42,137.72-87l92.76,31.56C5313.39,616.85,5226.36,679,5119.25,679c-140.58,0-247.69-108.07-247.69-244.83,0-137.71,107.11-244.82,247.69-244.82S5367,294.56,5365,438Zm-115.72-65c-21-64.07-66-91.81-130.06-91.81-81.29,0-137.72,54.51-147.28,130.06Z"></path>
          <path d="M5663.44,191.28V284a229.09,229.09,0,0,0-35.39-2.87c-74.6,0-123.37,49.73-123.37,135.8V669.45H5403.31V198.92h99.46V269.7c22-48.78,70.77-80.34,132-80.34C5647.17,189.36,5658.65,190.31,5663.44,191.28Z"></path>
        </g>
      </svg>
    </Box>
  );
};

export default Logo;
